/* eslint-disable no-restricted-syntax */
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';

import OneClickButton from '../../../components/form/button';
import addNotification from '../../../components/notification';
import Table from '../../../components/table/Table';

import ConfirmModal from './confirmModal';
import FilteringModal from './filteringModal';

import {
  createInventory,
  getListGenerateInventory,
  getNewGrouperCode,
  printInventory,
} from '../../../app/store/actions/inventory';

import ROUTES from '../../../config/routes';
import FormatHelpers from '../../../helpers/format';

class GenerateInventoryList extends React.Component {
  constructor(props) {
    super(props);

    this.breadcrumb = [
      {
        value:
          (
            <>
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </>),
      },
      { value: I18n.t('BEE1400' /* Movimentação */) },
      { value: I18n.t('BEE572' /* Inventário */) },
      { value: I18n.t('BEE1408' /* Gerar Inventário */), active: true },
    ];

    this.state = {
      checked: {},
      listProductsByAddress: [],
      showConfirm: false,
      defaultPageSize: 10,
      defaultSorted: [{ id: 'productCode', desc: false }],
      showFilterModal: false,
      showConfirmModal: false,
      tableFilter: null,
      listDeposit: [],
    };

    this.tableColumns = [
      {
        Header: I18n.t('BEE436' /* Selecionar */),
        accessor: 'action',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        filterable: false,
        sortable: false,
        Cell: (row) => (
          <div style={{ textAlign: 'center' }}>
            <input
              type="checkbox"
              checked={this.state.checked[row.original.id] || false}
              onChange={() => this.singleSelection(row.original)}
            />
          </div>
        ),
      }, {
        Header: I18n.t('BEE225' /* Produto */),
        accessor: 'productCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
      }, {
        Header: I18n.t('BEE1897' /* Descrição */),
        accessor: 'productName',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 300,
      }, {
        Header: I18n.t('BEE145' /* Filial */),
        accessor: 'branchCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      }, {
        Header: I18n.t('BEE182' /* Depósito */),
        accessor: 'depositCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      }, {
        Header: I18n.t('BEE428' /* Lote */),
        accessor: 'lotNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
      }, {
        Header: I18n.t('BEE3207' /* Última contagem */),
        accessor: 'lastCountAt',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        filterMethod: (filter, row) => {
          const input = _.lowerCase(filter.value);
          const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
          const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
          if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
            return true;
          }
        },
        Cell: (row) => (
          <span>
            {' '}
            {row.value ? moment(row.value).format('L LTS') : ''}
          </span>
        ),
      }, {
        Header: I18n.t('BEE3208' /* Contagens */),
        accessor: 'numberCountsYear',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      }, {
        Header: I18n.t('BEE267' /* Endereço */),
        accessor: 'addressCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
      }, {
        Header: I18n.t('BEE1854' /* Setor */),
        accessor: 'sector',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      }, {
        Header: I18n.t('BEE121' /* Rua */),
        accessor: 'street',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      }, {
        Header: I18n.t('BEE281' /* Coluna */),
        accessor: 'column',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      }, {
        Header: I18n.t('BEE283' /* Nível */),
        accessor: 'level',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      }, {
        Header: I18n.t('BEE285' /* Gaveta */),
        accessor: 'drawer',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      }, {
        Header: I18n.t('BEE355' /* Curva */),
        accessor: 'curve',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      }, {
        Header: I18n.t('BEE434' /* Data de Validade */),
        accessor: 'expirationDate',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        filterMethod: (filter, row) => {
          const input = _.lowerCase(filter.value);
          const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
          const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
          if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
            return true;
          }
        },
        Cell: (row) => (
          <span>
            {' '}
            {row.value ? moment(row.value).format('L') : ''}
          </span>
        ),
      }, {
        Header: I18n.t('BEE504' /* Total */),
        accessor: 'quantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      }, {
        Header: I18n.t('BEE530' /* Disponível */),
        accessor: 'available',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      }, {
        Header: I18n.t('BEE1431' /* Alocado */),
        accessor: 'allocated',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      },
    ];
  }

  singleSelection = (selection) => {
    const { checked } = this.state;
    checked[selection.id] = !checked[selection.id];
    this.setState({ checked: { ...checked } });
  };

  multipleSelection = (selectionOption) => {
    const { checked } = this.state;
    const data = this.reactTable.getResolvedState().sortedData;
    if (data && data.length > 0) {
      for (let index = 0; index < data.length; index += 1) {
        const element = data[index]._original;
        checked[element.id] = selectionOption;
      }
      this.setState({ checked: { ...checked } });
    }
  };

  validChecked = () => {
    const { checked } = this.state;

    if (!Object.keys(checked).length) {
      addNotification(
        'danger',
        I18n.t('BEE1408' /* Gerar Inventário */),
        I18n.t('BEE4113' /* Nenhum produto/endereço selecionado */),
        'top-right',
      );
    } else {
      const checkedSheetIds = [];
      for (const index in checked) {
        if (checked[index]) checkedSheetIds.push(index);
      }
      if (checkedSheetIds.length) {
        this.setState({
          checkedSheetIds: [...checkedSheetIds],
          showConfirm: true,
        });
      } else {
        addNotification(
          'danger',
          I18n.t('BEE1408' /* Gerar Inventário */),
          I18n.t('BEE4113' /* Nenhum produto/endereço selecionado */),
          'top-right',
        );
      }
    }
  };

  getListToGenerateInventory = async (tableFilter) => {
    try {
      const listProductsByAddress = await this.props.getListGenerateInventory(tableFilter);

      this.setState({
        tableFilter,
        listProductsByAddress: [...listProductsByAddress || []],
        checked: {},
      });
      this.closeFilters();
    } catch (err) {
      this.setState({ listProductsByAddress: [] });
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = (error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;
        addNotification('danger', I18n.t('BEE1408' /* Gerar Inventário */), messageError, 'top-right');
      } else {
        addNotification(
          'danger',
          I18n.t('BEE1408' /* Gerar Inventário */),
          I18n.t('BEE1969' /* Erro ao buscar dados */),
          'top-right',
        );
      }
    }
  };

  closeFilters = () => {
    this.setState({
      showFilterModal: false,
    });
  };

  closeConfirm = () => {
    this.setState({
      showConfirmModal: false,
    });
  };

  setValueList = (attr, value) => {
    this.setState({
      [attr]: value,
    });
  };

  createInventorySheets = async (paramsInventory) => {
    const {
      listProductsByAddress, checkedSheetIds, tableFilter,
    } = this.state;

    try {
      if (!paramsInventory) {
        addNotification(
          'danger',
          I18n.t('BEE1408' /* Gerar Inventário */),
          I18n.t('BEE3654' /* Os parâmetros para geração devem ser informados! */),
          'top-right',
        );
      } else {
        const sheetList = [];

        for (let index = 0; index < checkedSheetIds.length; index += 1) {
          const id = checkedSheetIds[index];
          const sheet = listProductsByAddress.find((prod) => prod.id === parseInt(id, 10));

          if (sheet) {
            sheetList.push({
              addressCode: sheet.addressCode,
              productCode: sheet.productCode,
              lotNumber: sheet.lotNumber,
              expirationDate: sheet.expirationDate,
              balanceQuantity: sheet.available,
              balanceAt: sheet.balanceAt,
              quantity: sheet.quantity,
              allocated: sheet.allocated,
              reserved: sheet.reserved,
              lastCountAt: sheet.lastCountAt,
              lastCountUser: sheet.lastCountUser,
              stockBalanceId: sheet.stockBalanceId,
            });
          }
        }

        const params = {
          grouperCode: paramsInventory.grouperCode,
          type: paramsInventory.inventoryType,
          branchInInventory: paramsInventory.branchInInventory,
          inventoryAt: paramsInventory.transactionDate,
          complementAddress: paramsInventory.complementAddress,
          branchCode: tableFilter.branchCode.value,
          depositCode: tableFilter.depositCode && tableFilter.depositCode.value ? tableFilter.depositCode.value : '',
          emptyAddress: tableFilter.considerEmptyAddress ? tableFilter.considerEmptyAddress.value : false,
          curves: tableFilter.curve ? tableFilter.curve.value.map((cv) => cv).toString() : '',
        };

        const result = await this.props.createInventory(params, sheetList);

        if (result && result.success === false) {
          addNotification(
            'danger',
            I18n.t('BEE1408' /* Gerar Inventário */),
            I18n.t('BEE3655' /* Erro ao gerar fichas de inventário. */),
            'top-right',
          );
        } else {
          addNotification(
            'success',
            I18n.t('BEE1408' /* Gerar Inventário */),
            I18n.t('BEE3656' /* Fichas de inventário geradas com sucesso! */),
            'top-right',
          );

          try { await this.props.printInventory(result); } catch (e) {
            // empty
          }

          this.setState({
            checked: {},
            listProductsByAddress: [],
            showConfirmModal: false,
          });
        }
      }
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = (error.details)
          ? `${error.code} - ${error.details}`
          : error.message;

        addNotification('danger', I18n.t('BEE1408' /* Gerar Inventário */), messageError, 'top-right');
      } else {
        addNotification(
          'danger',
          I18n.t('BEE1408' /* Gerar Inventário */),
          I18n.t('BEE3657' /* Não foi possível gerar o inventário. */),
          'top-right',
        );
      }
    }
  };

  render() {
    const {
      showConfirm, defaultPageSize, defaultSorted, listProductsByAddress, checkedSheetIds,
    } = this.state;

    return (
      <>
        <Table
          ref={(r) => {
            this.reactTable = r && r.reactTable;
          }}
          downloadCSV
          buttonFilter={{
            actionButton: () => { this.setState({ showFilterModal: true }); },
          }}
          breadcrumb={this.breadcrumb}
          headerTitle={I18n.t('BEE1408' /* Gerar Inventário */)}
          wikiHelp={ROUTES.MOVEMENT_INVENTORY_GENERATE_HELP}
          downButtonPosition
          actionButtons={(
            <div className="ml-auto">
              <button
                type="button"
                className="btn btn-120 btn-secondary p-5 m-5"
                onClick={() => this.multipleSelection(true)}
              >
                {I18n.t('BEE1908' /* Marcar Todos */)}
              </button>
              <button
                type="button"
                className="btn btn-120 btn-secondary p-5 m-5"
                onClick={() => this.multipleSelection(false)}
              >
                {I18n.t('BEE1909' /* Desmarcar Todos */)}
              </button>
              <OneClickButton
                type="button"
                className="btn btn-120 btn-primary p-5 m-5"
                onClick={() => this.validChecked()}
              >
                {I18n.t('BEE602' /* Gerar */)}
              </OneClickButton>
            </div>
          )}
          filterable
          data={listProductsByAddress}
          columns={this.tableColumns}
          expander
          defaultPageSize={defaultPageSize}
          defaultSorted={defaultSorted}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
          getTrProps={(state, rowInfo) => {
            if (rowInfo && rowInfo.row) {
              return {
                style: {
                  color: rowInfo.original.allocated > 0 ? '#bf4441' : 'black',
                },
              };
            }
            return {};
          }}
        />
        <FilteringModal
          showFilterModal={this.state.showFilterModal}
          closeFilters={this.closeFilters}
          getListToGenerateInventory={(tableFilter) => this.getListToGenerateInventory(tableFilter)}
          setValueList={(attr, value) => this.setValueList(attr, value)}
        />
        <ConfirmModal
          showConfirmModal={this.state.showConfirmModal}
          closeConfirm={this.closeConfirm}
          submitConfirm={this.createInventorySheets}
          tableFilter={this.state.tableFilter}
          getNewGrouperCode={this.props.getNewGrouperCode}
          listDeposit={this.state.listDeposit}
        />
        {(showConfirm
          && (
            <SweetAlert
              info
              showCancel
              cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
              confirmBtnText={I18n.t('BEE1849' /* Continuar */)}
              confirmBtnBsStyle="primary"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE101' /* Você tem certeza? */)}
              onConfirm={() => this.setState({ showConfirm: false, showConfirmModal: true })}
              onCancel={() => this.setState({ showConfirm: false, checkedSheetIds: [] })}
            >
              {I18n.t(
                'BEE4114',
                { 0: checkedSheetIds.length }, /* Serão geradas %{0} fichas de inventário. Deseja continuar? */
              )}
            </SweetAlert>
          )
        )}
      </>
    );
  }
}

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => ({
  getListGenerateInventory: (tableFilter) => dispatch(getListGenerateInventory(tableFilter)),
  createInventory: (params, sheetList) => dispatch(createInventory(params, sheetList)),
  printInventory: (grouperCode) => dispatch(printInventory(grouperCode)),
  getNewGrouperCode: (branchCode, type, date, depositCode) => dispatch(
    getNewGrouperCode(branchCode, type, date, depositCode),
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(GenerateInventoryList));
